export default __webpack_public_path__ + "static/media/ic-czech-language-primary.27ccc5f3.svg";